import React from "react";

export default ({ data }) => {
  return (
    <div>
      <img
        src={data.logo}
        alt={`${data.charity} Logo`}
        className="charity-logo"
      />
      <div className="links">
        {data.links.map((item, index) => {
          return (
            item.url && (
              <a
                key={index}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  className={
                    item.name === "facebook"
                      ? "fa fa-facebook-official fa-2x"
                      : item.name === "twitter"
                      ? "fa fa-twitter-square fa-2x"
                      : item.name === "instagram"
                      ? "fa fa-instagram fa-2x"
                      : "fa fa-share-square-o fa-2x"
                  }
                />
              </a>
            )
          );
        })}
      </div>
    </div>
  );
};
